// TickMarkers.tsx
import React from 'react';
import styles from './VideoTimeline.module.css';
import { formatTime } from '../utils/time'; // create a helper in utils/time.ts

interface TickMarkersProps {
  ticks: number[];
  duration: number;
}

const TickMarkers: React.FC<TickMarkersProps> = ({ ticks, duration }) => {
  return (
    <>
      {ticks.map((tick, index) => {
        const left = (tick / duration) * 100;
        return (
          <div key={index} className={styles.tickMarker} style={{ left: `${left}%` }}>
            {formatTime(tick)}
          </div>
        );
      })}
    </>
  );
};

export default TickMarkers;
